import { inject } from '@angular/core';
import { Router, CanActivateFn, CanDeactivateFn } from '@angular/router';
import { map, catchError, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { SupplierService } from '../services/supplier.service';

/**
 * Guard который проверяет что поставщик зарегистрирован
 * Если нет - перенаправляет на /supplier-registration
 */
export const supplierRegistrationGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const supplierService = inject(SupplierService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return true;
  }

  const userRoles = authService.userRoles();
  if (!userRoles.includes('quota_supplier')) {
    return true;
  }

  return supplierService.checkRegistrationStatus().pipe(
    map(isRegistered => {
      if (!isRegistered) {
        router.navigate(['/user/external']);
        return false;
      }
      return true;
    }),
    catchError(() => {
      router.navigate(['/user/external']);
      return of(false);
    })
  );
};

/**
 * CanDeactivate guard для страницы регистрации
 * Не позволяет уйти пока не зарегистрирован
 */
export const canLeaveRegistrationGuard: CanDeactivateFn<any> = () => {
  const supplierService = inject(SupplierService);

  const isRegistered = supplierService.isRegistered();

  if (isRegistered === false) {
    console.log('Cannot leave registration page until registered');
    alert('Пожалуйста, заполните форму регистрации поставщика');
    return false;
  }

  return true;
};
